// Site-wide settings, navigation and shared copy.
export const SITE = {
  name: "Wandering Glider Experiences",
  legalName: "Wandering Glider Experiences LLP",
  tagline: "The world is our classroom.",
  positioning: "Learn the World by Wandering Through It",
  phone: "+91 79890 66338",
  phoneHref: "tel:+917989066338",
  email: "hello@wanderinggliders.com",
  emailHref: "mailto:hello@wanderinggliders.com",
};

export const MAIN_NAV = [
  { label: "About Us", to: "/about" },
  { label: "Our Approach", to: "/our-approach" },
  { label: "Journeys", to: "/journeys" },
  { label: "Our People", to: "/our-people" },
];

export const JOURNEY_MENU = [
  { type: "link", label: "All Journeys", to: "/journeys" },
  { type: "label", label: "Schools" },
  { type: "link", label: "Tide Trails, Goa", to: "/journeys/tide-trails-goa" },
  { type: "link", label: "Lessons from the Wild, Pench", to: "/journeys/lessons-from-the-wild-pench" },
  { type: "label", label: "Coming Soon" },
  { type: "link", label: "Pondicherry", to: "/journeys/coming-soon#pondicherry" },
  { type: "link", label: "Jaipur", to: "/journeys/coming-soon#jaipur" },
  { type: "link", label: "Hampi", to: "/journeys/coming-soon#hampi" },
  { type: "link", label: "Ladakh", to: "/journeys/coming-soon#ladakh" },
  { type: "link", label: "Bespoke Experiences", to: "/journeys/bespoke-experiences" },
];

export const APPROACH_PRINCIPLES = [
  {
    number: "01",
    title: "Place is the teacher",
    text: "The destination itself becomes the classroom, from dense rainforest to coastal village to mountain trail. Learners engage directly with the landscapes, cultures and communities they travel through.",
  },
  {
    number: "02",
    title: "Slow, on purpose",
    text: "We move intentionally, taking time to observe, ask questions and let curiosity lead the way, rather than rushing from one sight to another.",
  },
  {
    number: "03",
    title: "Hands, heart, story",
    text: "Hands-on experience, storytelling and reflection help participants connect deeply with the environments they explore.",
  },
  {
    number: "04",
    title: "Across disciplines",
    text: "Knowledge is drawn from the land, its history and its people, so ecology, culture, art and science meet in a single living lesson.",
  },
];

export const SAFETY_COPY = {
  heading: "Safety & Wellbeing",
  home: "Every journey is planned with thought and care. Routes, activities and group needs are considered well before we travel, risk assessments are conducted in advance, and trained First Aid responders accompany every programme. Just as importantly, we shape an atmosphere in which participation is supported, inclusion matters and challenge is always by choice.",
  approach: [
    "Feeling safe is a precondition for curiosity. Every Wandering Glider journey is planned thoughtfully, with routes, activities and group needs considered well in advance, so that challenge feels exciting rather than overwhelming.",
    "Every programme is supervised by experienced facilitators, outdoor professionals and local experts, and trained First Aid responders accompany each journey. Risk assessments are conducted in advance, and a dedicated facilitator-to-participant ratio ensures appropriate supervision throughout.",
    "Participation is always supported, and challenge is always by choice. We pay as much attention to emotional wellbeing as to physical safety, and we design experiences in which every participant can take part meaningfully, whatever their confidence or ability.",
  ],
};

export const NAME_INSPIRATION = {
  heading: "The Glider Behind The Name",
  lede: "Tiny dragonfly. Extraordinary traveller.",
  paragraphs: [
    "Every year, swarms of Wandering Gliders, tiny dragonflies that are just 5 cm long and weigh a mere 300 mg, undertake the longest migration in the insect world — following the monsoon across the Indian Ocean on an extraordinary multi-generational journey of nearly 18,000 km.",
    "But what fascinates us isn't just how far they go. Their journeys connect ecosystems across oceans, skies and continents — and remind us that the natural world is deeply interconnected.",
  ],
};

export const PEOPLE_INTRO_HOME =
  "Our journeys are shaped by the people who lead them: curious, warm and wonderfully detail-obsessed educators, naturalists, artists and storytellers who make every journey feel like an adventure.";

export const CONTACT_INTRO =
  "Whether you're a school coordinator planning a term excursion, a parent looking for something genuinely enriching, or an adult ready to wander more slowly - we'd love to hear from you.";

export const PEOPLE_INTRO =
  "After years of wandering, learning, and working in the wildest corners of the country, we've gathered some of the best facilitators you'll ever meet. These people are more than just experts in their fields. They're curious, warm, and wonderfully detail-obsessed - noticing the big stuff, the small stuff, and the things you didn't even know you needed. They hold space for wonder, questions, laughter, and the kind of moments that stay with you long after you've gone home. They're the ones who make every Wandering Glider journey feel like an adventure you'll want to stay on forever.";

export const AI_PERSPECTIVE =
  "As AI becomes part of everyday life, we place particular value on creativity, emotional understanding, adaptability, critical thinking and thoughtful decisions in uncertain situations.";

export const MARQUEE_WORDS = [
  "Curiosity",
  "Observation",
  "Slow travel",
  "Connection",
  "Place",
  "Story",
  "Wonder",
];
